<template>
    <input-group
        v-model="relatieType"
        :items="availableRelatieTypes"
        :schema="props.schema"
    >
        <template #label>
            <flex-container :gap="Size.sm">
                <input-label>
                    <slot name="label">
                        De flow moet starten als het relatie type wijzigt naar:
                    </slot>
                </input-label>

                <span v-tooltip.info="props.tooltip">
                    <svg-icon
                        :icon="IconCircleInfo"
                        :size="IconSize.sm"
                        is-custom-icon
                    />
                </span>
            </flex-container>
        </template>

        <template #input>
            <select-input :items="availableRelatieTypes" />
        </template>
    </input-group>
</template>

<script setup lang="ts">
    import {
        FlexContainer,
        IconSize,
        InputLabel,
        Size,
        SvgIcon,
    } from '@keyvue/one-ui';

    import { onMounted, ref, watch } from 'vue';
    import { string } from 'yup';
    import IconCircleInfo from '@keyvue/one-awesome-icons/icons/regular/circle-info.svg?component';
    import { RealworksAPI } from '@keyvue/one-api-client-legacy';

    interface Props {
        modelValue: string | null;
        tooltip?: string;
        placeholder?: string;
        schema?: any;
    }

    const props = withDefaults(defineProps<Props>(), {
        tooltip: 'De flow moet starten als het relatie type wijzigt naar:',
        placeholder: 'Selecteer relatie type',
        schema: () => string().required(),
    });

    const emit = defineEmits<{
        (e: 'loading'): void;
        (e: 'loaded'): void;
        (e: 'update:modelValue', value: string | null): void;
    }>();

    const relatieType = ref(props.modelValue);

    const availableRelatieTypes = ref<string[]>([]);

    async function loadData() {
        emit('loading');
        availableRelatieTypes.value = (await RealworksAPI.getRelatietypes())
            .sort((a, b) => a.localeCompare(b));
        emit('loaded');
    }

    onMounted(() => {
        loadData();
    });

    watch(relatieType, () => {
        emit('update:modelValue', relatieType.value);
    });

    watch(() => props.modelValue, () => {
        relatieType.value = props.modelValue;
    });
</script>
